/**
 * The closed-period rule, in one place.
 *
 * An administrator sets the organization's `timesheetLockDate`; from then on a regular user can
 * no longer add, change or delete hours dated **before** it. The lock date itself stays open, so
 * closing September is setting 1 October — the boundary an admin would actually type.
 *
 * Administrators are never subject to it: someone has to be able to correct a closed month, and
 * every edit they make to another person's hours is already in the audit log.
 *
 * Both sides of the application answer the question with this function: the browser to grey a
 * cell out and refuse to send, the server to refuse what is sent anyway. Nothing else may decide
 * which days are closed, or the two would eventually disagree about the same day.
 *
 * `null` locks nothing. Dates compare as strings because `YYYY-MM-DD` sorts chronologically.
 */
export function isTimesheetLocked(entryDate, lockDate, role) {
    if (role === 'ADMIN')
        return false;
    return lockDate !== null && entryDate < lockDate;
}
//# sourceMappingURL=timesheet-lock.js.map